/**
 * BlueprintGrid — faint full-viewport grid that sits behind every scene
 * and never changes. 24px minor / 120px major, ultra-low alpha so it only
 * registers as paper texture. Single most important element for making
 * the whole landing feel like it came from the same instrument.
 */
import { ALPHA } from "./designTokens";

export function BlueprintGrid() {
  const minor = `rgba(255, 255, 255, ${ALPHA.gridFaint})`;
  const major = `rgba(255, 255, 255, ${ALPHA.gridMajor})`;

  return (
    <div
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        backgroundImage:
          `linear-gradient(${minor} 1px, transparent 1px),` +
          `linear-gradient(90deg, ${minor} 1px, transparent 1px),` +
          `linear-gradient(${major} 1px, transparent 1px),` +
          `linear-gradient(90deg, ${major} 1px, transparent 1px)`,
        backgroundSize: "24px 24px, 24px 24px, 120px 120px, 120px 120px",
        zIndex: 0,
      }}
    />
  );
}
